module.exports = __webpack_public_path__ + "static/img/SOHO_EP.5ae65eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/SOHO_EP.jpg
// module id = jnYf
// module chunks = 0